// Copyright (c) 2016 Deere & Company

import PreferredTheme, {getDefaultState as getPreferredThemeDefaultState} from './preferred-theme';
import t from 'tcomb';

const ThemeSettings = t.struct({
    preferredTheme: PreferredTheme
}, {
    name: 'ThemeSettings',
    strict: true
});

export const getDefaultState = () => new ThemeSettings({
    preferredTheme: getPreferredThemeDefaultState()
});

export default ThemeSettings;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/theme-settings.js